var path = 'public/app/features/manage-dashboards/partials/dashboard_list.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <manage-dashboards/>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;